import * as React from 'react';
import { useSelector } from 'react-redux';

import { Avatar } from '../../../components/Avatar';
import { getQuestionById } from '../../../selectors/questions';

interface IAvatarContainerProps {
  questionId: string;
}

export function AvatarContainer({ questionId }: IAvatarContainerProps): React.JSX.Element {
  const { user } = useSelector(getQuestionById(questionId));

  return <Avatar avatarUrl={user.avatarUrl} type={user.type} />;
}
